import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import ModelSelector from './components/ModelSelector';
import ColorSelector from './components/ColorSelector';
import StrapSelector from './components/StrapSelector';
import CaseSelector from './components/CaseSelector';
import ConfigurationSummary from './components/ConfigurationSummary';

import CheckoutBar from '../../components/CheckoutBar';

import models from '../../data/models';
import straps from '../../data/straps';
import cases from '../../data/cases';

import './style.css';

export default function Content(props) {
  function selectModel(m) {
    props.setSelectedModel(m)

    // if the model changes, everything is reset
    props.setSelectedColor()
    props.setSelectedStrap()
    props.setSelectedCase()

    props.setStep(2)
  }

  function selectColor(c) {
    props.setSelectedColor(c)

    props.setStep(props.selectedCase ? 5 : 3)
  }

  function selectStrap(s) {
    props.setSelectedStrap(s)

    props.setStep(props.selectedCase ? 5 : 4)
  }

  function selectCase(c) {
    props.setSelectedCase(c)

    props.setStep(5)
  }

  let activeScope;
  switch (props.step) {
    case 1:
      activeScope = (
        <ModelSelector
          locale={props.locale}
          selectModel={(i, e) => selectModel(i, e)}
          models={models}
          />
      )
      break;
    case 2:
      activeScope = (
        <ColorSelector
          locale={props.locale}
          selectColor={(i, e) => selectColor(i, e)}
          selectedModel={props.selectedModel}
          />
      )
      break;
    case 3:
      activeScope = (
        <StrapSelector
          locale={props.locale}
          selectStrap={(i, e) => selectStrap(i, e)}
          selectedModel={props.selectedModel}
          straps={straps}
          />
      )
      break;
    case 4:
      activeScope = (
        <CaseSelector
          locale={props.locale}
          selectCase={(i, e) => selectCase(i, e)}
          cases={cases}
          />
      )
      break;
    case 5:
      activeScope = (
        <ConfigurationSummary
          locale={props.locale}
          selectedModel={props.selectedModel}
          selectedColor={props.selectedColor}
          selectedStrap={props.selectedStrap}
          selectedCase={props.selectedCase}
          setStep={s => props.setStep(s)}
          />
      )
      break;
    default:
      activeScope = (
        <p>No content for {props.step} of type {typeof props.step}</p>
      )
  }

  let conditionalCheckoutBar;
  if (props.selectedModel && props.selectedColor && props.selectedStrap && props.selectedCase) {
    conditionalCheckoutBar = (
      <CheckoutBar
      locale={props.locale}
        selectedModel={props.selectedModel}
        selectedColor={props.selectedColor}
        selectedStrap={props.selectedStrap}
        selectedCase={props.selectedCase}
        setStep={s => props.setStep(s)}
        />
    )
  }

  return (
    <div className="Content">
      {activeScope}

      {conditionalCheckoutBar}
    </div>
  )
}
